// extracted by mini-css-extract-plugin
export default {"Logo":"Form_Logo__6cJfp"};